(() => {
  'use strict';

  if (window.joffzCollectionKeyboardBoundariesReady) return;
  window.joffzCollectionKeyboardBoundariesReady = true;

  const focusableSelector = 'a[href], area[href], button, input:not([type="hidden"]), select, textarea, iframe, object, embed, summary, [tabindex]';

  function visibleTabStops(dialog) {
    return Array.from(dialog.querySelectorAll(focusableSelector))
      .filter((element) => {
        if (element.tabIndex < 0 || element.matches(':disabled')) return false;
        if (element.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
        const visibility = getComputedStyle(element).visibility;
        return element.getClientRects().length > 0 && visibility !== 'hidden' && visibility !== 'collapse';
      })
      .map((element, index) => ({ element, index, order: element.tabIndex > 0 ? element.tabIndex : Infinity }))
      .sort((a, b) => a.order === b.order ? a.index - b.index : a.order - b.order)
      .map(({ element }) => element);
  }

  // Capture only the actual Tab boundaries before the theme's unfiltered focus trap.
  // Recompute on every key press because variant forms and gallery visibility can change.
  document.addEventListener('keydown', (event) => {
    if (event.defaultPrevented || event.key !== 'Tab' || event.altKey || event.ctrlKey || event.metaKey) return;
    if (!(event.target instanceof Element)) return;

    const modal = event.target.closest('quick-add-modal.joffz-collection-quick-modal[open]');
    if (!modal) return;
    const dialog = modal.querySelector('.quick-add-modal__content[role="dialog"]');
    if (!dialog || !dialog.contains(event.target)) return;

    const stops = visibleTabStops(dialog);
    const first = stops[0];
    const last = stops[stops.length - 1];
    const active = document.activeElement;
    let destination;

    if (!stops.length) destination = dialog;
    else if (event.shiftKey && (active === first || active === dialog)) destination = last;
    else if (!event.shiftKey && active === last) destination = first;

    if (!destination) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    destination.focus();
  }, true);
})();
